import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ title, description }) => (
  <header className="layout__header">
    <div className="layout__title">
      <h1>{title}</h1>
      <p className="no-margin">{description}</p>
    </div>
  </header>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js